export enum ReadyStatus {
  READY = 'ready',
  NOT_VALID = 'not-valid',
  NOT_READY = 'not-ready',
  NOT_FULLY_CONNECTED = 'not-fully-connected',
  UNDEFINED = 'undefined',
}
